import _extends from "@babel/runtime/helpers/extends";
import { render, unmountComponentAtNode } from "react-dom";
import { FeedbackModal, Provider } from "../components";
import { RootStore } from "../store";

function listenPluginDeactivation() {
  document.addEventListener("click", e => {
    const {
      names,
      currentUserFullName
    } = RootStore.get.optionStore.others;
    const link = e === null || e === void 0 ? void 0 : e.target;

    for (const slug in names) {
      const {
        plugin,
        hasAtLeastOneActiveLicense,
        isPluginActiveForNetwork
      } = names[slug];

      if (link.matches("tr[data-plugin=\"".concat(plugin, "\"] a[href*=\"action=deactivate\"]"))) {
        const node = document.createElement("div");
        document.body.appendChild(node);
        render( /*#__PURE__*/React.createElement(Provider, null, /*#__PURE__*/React.createElement(FeedbackModal, _extends({}, names[slug], {
          initialValues: {
            name: currentUserFullName
          },
          plugin: slug,
          hasAtLeastOneActiveLicense: hasAtLeastOneActiveLicense,
          isPluginActiveForNetwork: isPluginActiveForNetwork,
          onClose: () => {
            unmountComponentAtNode(node);
          },
          onDeactivate: () => {
            window.location.href = link.href;
          }
        }))), node);
        e.preventDefault(); // Stop `real-utils` functionality

        e.stopImmediatePropagation();
        break;
      }
    }
  }, true);
}

export { listenPluginDeactivation };